















import { Component, Vue, Watch } from "vue-property-decorator";
import { startOfMonth, endOfMonth } from "date-fns";
import { Circle2 } from "vue-loading-spinner";
import { fileOpen, fileDownload } from "@/file-utils";

import PaginatedSearch from "@/layouts/DashboardLayoutComponents/SoniprevPaginatedSearch.vue";
import ShiftFilter from "@/layouts/DashboardLayoutComponents/ShiftFilter.vue";

import reportModel from "@/models/report.model";

@Component({
	components: {
		ShiftFilter,
		PaginatedSearch,
		Circle2,
	},
})
export default class WeekdayWeekendReport extends Vue {
	shiftModel: any;
	shiftFilter: any = {};
	shiftId: any = null;
	fileDownloading = false;

	constructor() {
		super();
	}

	updateFilter(filter: any)  {
		this.shiftFilter = filter;
	}

	async getReport(kind: "DOWNLOAD" | "OPEN") {
		if(!this.validateForm()) {
			return;
		}

		this.fileDownloading = true;
		try {
			const pdfBlob = await reportModel.getWeekdayWeekendReport(this.shiftFilter);
			if (kind === "DOWNLOAD") {
				fileDownload(pdfBlob, 'relatorio-dia-fim-semana.pdf');
			} else if (kind === "OPEN") {
				fileOpen(pdfBlob);
			}
		} catch (error) {
			this.$toasted.error(error.friendlyMessage || 'Não foi possível gerar o relatório. Tente novamente.');
			console.error(error);
		}
		this.fileDownloading = false;
	}

	validateForm(): boolean {
		if (!this.shiftFilter.totalKind) {
			this.$toasted.error('É necessário selecionar um tipo de valor!');
			return false
		}

		return true;
	}
}
